export enum State {
    unavailable,
    soldout,
    available1,
    available2,
    available3
}